var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCopy = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 21"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  d: "M16.693 5.25H7.588A2.34 2.34 0 0 0 5.25 7.588v9.105a2.34 2.34 0 0 0 2.338 2.338h9.105a2.34 2.34 0 0 0 2.338-2.338V7.588a2.34 2.34 0 0 0-2.338-2.338Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  d: "m15.73 5.25.02-.984a2.303 2.303 0 0 0-2.297-2.297h-8.86A2.633 2.633 0 0 0 1.97 4.594v8.86a2.303 2.303 0 0 0 2.297 2.296h.984"
})));
export default SvgIconCopy;